module.exports = __webpack_public_path__ + "view_magnify_lightblue_zoom_type.ae576.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/view_magnify_lightblue_zoom_type.svg
// module id = ./src/_asset/sources/assets/images/@svg/view_magnify_lightblue_zoom_type.svg
// module chunks = main